"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var gsap_1 = require("gsap");
var swiper_1 = require("swiper");
// ハンバーガーメニュー
var humMenu = function () {
    var menu = document.querySelector('#menu');
    var menuBtn = document.getElementById('menu-btn');
    if (menu != null && menuBtn != null) {
        menuBtn.addEventListener('click', function () {
            if (menuBtn.classList.contains('active')) {
                menuBtn.classList.remove('active');
                menu.classList.remove('active');
            }
            else {
                menuBtn.classList.add('active');
                menu.classList.add('active');
            }
        });
    }
};
var headerMargin = function () {
    var header = document.getElementById('header');
    if (header === null) {
        return;
    }
    var headerHeight = header.clientHeight;
    var body = document.querySelector('body');
    if (body === null) {
        return;
    }
    var addMargin = document.querySelectorAll('.header-margin-add');
    for (var i = 0; i < addMargin.length; i++) {
        addMargin[i].style.marginTop = headerHeight + 'px';
    }
};
var fvAnimation = function () {
    function fuwafuwaAnimationTop(target) {
        var randomY = gsap_1.gsap.utils.random(60, 150); // 10以上のランダムな数値を生成
        var randomDuration = gsap_1.gsap.utils.random(1.5, 2.5); // ランダムなアニメーション時間を設定
        gsap_1.gsap.to(target, {
            y: "+=".concat(randomY), // 上下にランダムで移動
            duration: randomDuration, // ランダムな時間
            ease: 'power1.inOut', // スムーズな動きにする
            yoyo: true, // 上下に繰り返し動く
            repeat: -1, // 無限に繰り返す
        });
    }
    var elements = document.querySelectorAll('.huwahuwatop');
    elements.forEach(function (element) {
        fuwafuwaAnimationTop(element);
    });
    function animateElementToOriginalPosition(element) {
        var offsetX = (Math.random() - 0.5) * 800; // -400pxから+400pxの範囲内でランダム
        var offsetY = (Math.random() - 0.5) * 800; // -400pxから+400pxの範囲内でランダム
        // ランダムな位置に初期配置（800pxの範囲内）
        gsap_1.gsap.set(element, {
            x: offsetX,
            y: offsetY,
            opacity: 0, // 初期状態で透明にする
        });
        // 元の位置に戻るアニメーション
        gsap_1.gsap.to(element, {
            x: 0,
            y: 0,
            opacity: 1, // 元の位置に戻りながら不透明にする
            duration: gsap_1.gsap.utils.random(1.5, 2.5), // ランダムな速さ
            ease: 'power2.inOut',
        });
    }
    var boxes = document.querySelectorAll('.box');
    boxes.forEach(function (box) {
        animateElementToOriginalPosition(box);
    });
    gsap_1.gsap.to('.fv-title-animation', {
        opacity: 1,
        duration: 2,
        delay: 1.5,
        ease: 'power2.inOut',
    });
    function fuwafuwaAnimation(target) {
        gsap_1.gsap.to(target, {
            y: gsap_1.gsap.utils.random(-50, 50),
            duration: gsap_1.gsap.utils.random(1.5, 2.5),
            ease: 'power1.inOut',
            yoyo: true,
            repeat: -1,
            delay: 3.5,
        });
    }
    var fuwafuwaElements = document.querySelectorAll('.fuwafuwa');
    fuwafuwaElements.forEach(function (element) {
        fuwafuwaAnimation(element); // 必要ならここで個別にアサーション
    });
    gsap_1.gsap.to('.image', {
        duration: 5,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut',
        motionPath: {
            path: [
                { x: 0, y: 0 },
                { x: 100, y: -50 },
                { x: 200, y: 0 },
                { x: 100, y: 50 },
                { x: 0, y: 0 },
            ],
            curviness: 1.5,
            autoRotate: true,
        },
    });
};
var topAnimation = function () {
    // gsap.registerPlugin(ScrollTrigger)
    gsap_1.gsap.from('.top-about1', {
        opacity: 0,
        y: 50,
        scrollTrigger: {
            trigger: '.top-about1',
            start: 'top 80%',
            toggleActions: 'play none none none',
        },
    });
    gsap_1.gsap.from('.top-about2', {
        opacity: 0,
        y: 50,
        scrollTrigger: {
            trigger: '.top-about2',
            start: 'top 80%',
            toggleActions: 'play none none none',
        },
    });
    gsap_1.gsap.from('.top-about3', {
        opacity: 0,
        y: 50,
        scrollTrigger: {
            trigger: '.top-about3',
            start: 'top 80%',
            toggleActions: 'play none none none',
        },
    });
    gsap_1.gsap.from('.top-about4', {
        opacity: 0,
        y: 50,
        scrollTrigger: {
            trigger: '.top-about4',
            start: 'top 80%',
            toggleActions: 'play none none none',
        },
    });
    gsap_1.gsap.from('.top-about5', {
        opacity: 0,
        y: 50,
        scrollTrigger: {
            trigger: '.top-about5',
            start: 'top 80%',
            toggleActions: 'play none none none',
        },
    });
};
var activitySwiper = function () {
    var swiper = new swiper_1.default('.activity-slider', {
        modules: [swiper_1.Autoplay],
        loop: true,
        slidesPerView: 1,
        speed: 1000,
        autoplay: {
            delay: 3000,
        },
        breakpoints: {
            767: {
                slidesPerView: 1.6,
            },
        },
    });
    swiper.init();
};
var blaSwiper = function () {
    var swiper = new swiper_1.default('.swiper-bla', {
        modules: [swiper_1.Autoplay],
        slidesPerView: 3.6,
        loop: true,
        speed: 4000,
        spaceBetween: 20,
        centeredSlides: true,
        autoplay: {
            delay: 0,
        },
        breakpoints: {
            767: {
                slidesPerView: 5,
            },
        },
    });
    swiper.init();
};
var activityreportSwiper = function () {
    // スライド数を取得
    var swiperContainer = document.querySelector('.swiper-activity-report');
    var slides = swiperContainer === null || swiperContainer === void 0 ? void 0 : swiperContainer.querySelectorAll('.swiper-slide');
    var slideCount = slides ? slides.length : 0;
    if (!swiperContainer || slideCount < 3) {
        // スライドが少ない場合は初期化しない
        return;
    }
    var swiper = new swiper_1.default('.swiper-activity-report', {
        modules: [swiper_1.Autoplay],
        slidesPerView: 1.4,
        loop: slideCount >= 3, // 3枚以上のみループを有効化
        spaceBetween: 20,
        centeredSlides: true,
        speed: 1000,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false, // ユーザーが操作しても自動再生を続ける
        },
        breakpoints: {
            767: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
        },
    });
};
var facilitySwiper = function () {
    var swiper = new swiper_1.default('.swiper-facility', {
        modules: [swiper_1.Autoplay],
        slidesPerView: 3.8,
        loop: true,
        spaceBetween: 20,
        centeredSlides: true,
        speed: 1000,
        autoplay: {
            delay: 3000,
        },
        breakpoints: {
            767: {
                slidesPerView: 4.6,
                spaceBetween: 30,
            },
        },
    });
};
document.querySelectorAll('.accordion-header').forEach(function (header) {
    header.addEventListener('click', function () {
        var content = header.nextElementSibling;
        if (content.style.display === 'block') {
            content.style.display = 'none';
        }
        else {
            content.style.display = 'block';
        }
    });
});
var payJpRemoveForm = function () {
    var form = document.querySelector('.simplepayjppayment-container form');
    if (form !== null) {
        var inputEmail = document.querySelector('#simplepayjppayment-mail');
        var labelEmail = document.querySelector('[for="simplepayjppayment-mail"]');
        if (inputEmail !== null && labelEmail !== null) {
            inputEmail.style.display = 'none';
            labelEmail.style.display = 'none';
        }
    }
};
var payJpRewriteForm = function () {
    var form = document.querySelector('.simplepayjppayment-container form');
    if (form !== null) {
        var inputName = document.querySelector('#simplepayjppayment-name');
        var labelName = Array.from(document.querySelectorAll('label')).find(function (label) { return label.textContent === '氏名:'; });
        if (inputName !== null && labelName !== undefined) {
            inputName.placeholder = 'ひみつきち太郎 / 宮崎県宮崎市加江田6411';
            inputName.required = true;
            inputName.style.marginBottom = '.5rem';
            labelName.innerHTML =
                '氏名 / 住所<span style="color: #f00; margin-left: 1rem;">(必須)</span>';
            // 新しいdiv要素を作成
            var div = document.createElement('div');
            div.textContent = '入力例：ひみつきち太郎 / 宮崎県宮崎市加江田6411';
            div.style.fontSize = '14px';
            div.style.color = '#f00';
            div.style.marginBottom = '1rem';
            // inputNameの親要素を取得
            var parent_1 = inputName.parentNode;
            if (parent_1 !== null) {
                // inputNameの後にdiv要素を挿入
                parent_1.insertBefore(div, inputName.nextSibling);
            }
        }
    }
};
// ページが読み込まれる前に、containerの中をopacity: 0にする。読み込みが完了したら、opacity: 1にする
var formLoading = function () {
    var container = document.querySelector('.donation-form');
    if (container !== null) {
        window.addEventListener('load', function () {
            container.style.opacity = '1';
        });
    }
};
var formSubmitValidation = function () {
    var form = document.querySelector('.simplepayjppayment-container form');
    if (form !== null) {
        var submit_1 = document.querySelector('#payjp_checkout_box input[type="button"]');
        var inputName_1 = document.querySelector('#simplepayjppayment-name');
        var amountControl_1 = document.getElementById('amount-control');
        var hiddenAmount_1 = document.querySelector("input[name='amount']");
        var errorMessage_1 = document.getElementById('error-message');
        if (submit_1 !== null && inputName_1 !== null) {
            // ボタンの状態を更新する関数
            var updateSubmitButtonState_1 = function () {
                var isAmountValid = true; // amountControlがない場合はtrueにする
                if (amountControl_1 !== null) {
                    var amountValue = parseInt(amountControl_1.value, 10);
                    isAmountValid = !isNaN(amountValue) && amountValue >= 1000;
                }
                var isNameValid = inputName_1.value !== '';
                submit_1.disabled = !isAmountValid || !isNameValid; // 金額と名前のバリデーション
                submit_1.style.opacity = submit_1.disabled ? '.5' : '1'; // ボタンが無効なときのスタイル
                submit_1.style.cursor = submit_1.disabled ? 'not-allowed' : 'pointer'; // カーソルを変更
                if (errorMessage_1 !== null) {
                    errorMessage_1.style.display = isAmountValid ? 'none' : 'block';
                }
            };
            // 初期状態ではボタンを無効化
            updateSubmitButtonState_1();
            // inputNameの入力内容が変更されたときの処理
            inputName_1.addEventListener('input', function () {
                updateSubmitButtonState_1();
            });
            // amountControlの入力内容が変更されたときの処理
            if (amountControl_1 !== null) {
                amountControl_1.addEventListener('input', function () {
                    if (hiddenAmount_1 !== null) {
                        hiddenAmount_1.value = amountControl_1.value;
                    }
                    updateSubmitButtonState_1();
                });
            }
        }
    }
};
document.addEventListener('DOMContentLoaded', function () {
    payJpRemoveForm();
    payJpRewriteForm();
    formLoading();
    formSubmitValidation();
});
window.addEventListener('load', function () {
    humMenu();
    fvAnimation();
    topAnimation();
    headerMargin();
    activitySwiper();
    blaSwiper();
    activityreportSwiper();
    facilitySwiper();
});
